module.exports = __webpack_public_path__ + "img/hook_MARTEC_BK_4.8a2be48b.png";